module.exports = __webpack_public_path__ + "static/img/newLoad_circle5.d33294e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_circle5.png
// module id = 6PqJ
// module chunks = 3